
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#00374E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.112 15.692c-.745 0-1.216.364-1.5.81h-.02l.01-.72H12.17c-.126 0-.247.154-.247.3v4.397c0 .147.12.29.255.29H13.6v-2.467c0-.719.2-1.285.923-1.285.693 0 .798.495.798 1.153v2.306c0 .152.12.293.245.293H17v-2.943c0-1.204-.388-2.134-1.888-2.134zm10.436 4.03c-.68 0-1.143-.524-1.143-1.291 0-.767.463-1.292 1.143-1.292.68 0 1.133.525 1.133 1.292s-.453 1.291-1.133 1.291zm.213-3.907c-.621 0-1.048.22-1.306.454.006-.17.012-.42.012-.667V14H23.15c-.116 0-.228.148-.228.282v6.1c0 .146.109.28.231.28h1.236l-.006-.39c.352.339.833.497 1.367.497 1.38 0 2.249-1.082 2.249-2.481 0-1.4-.87-2.473-2.24-2.473zm-14.834.117H9.283a.491.491 0 00-.334.154l-1.353 1.446V14H6.235c-.12 0-.235.148-.235.285v6.204c0 .139.095.28.236.28h1.36v-1.461l.438-.423 1.09 1.703c.103.139.244.181.407.181h1.546l-1.945-3.022 1.795-1.815zm9.737 3.382c-.09.17-.347.446-.73.446-.39 0-.665-.228-.665-.604 0-.366.258-.574.693-.593l.702-.05v.801zm.888-3.058c-.346-.356-.817-.564-1.635-.564-.7 0-1.3.21-1.693.401-.1.052-.14.204-.1.32l.292.803c.222-.158.782-.435 1.341-.435.57 0 .898.267.898.781v.11l-1.102.05c-.809.039-1.707.405-1.707 1.493 0 1.09.819 1.554 1.591 1.554.712 0 1.067-.416 1.254-.623l.018.332a.198.198 0 00.194.182h1.174v-2.75c0-.823-.187-1.298-.525-1.654z","fill":"#fff"}})])
          )
        }
      }
    